import React from 'react';
import {
  Container,
  Description,
  EmptyImg,
  ContainerWithoutPading,
  DescriptionSmallText,
} from './EmptyInvoice.styles';

const EmptyInvoice = ({icon, description, showContainer = true}) => {
  return showContainer ? (
    <Container>
      {icon && <EmptyImg src={icon} alt="image" />}
      {description && <Description dangerouslySetInnerHTML={{__html: description}} />}
    </Container>
  ) : (
    <ContainerWithoutPading>
      {icon && <EmptyImg src={icon} alt="image" />}
      {description && <DescriptionSmallText dangerouslySetInnerHTML={{__html: description}} />}
    </ContainerWithoutPading>
  );
};

export default EmptyInvoice;
